import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

import Layout from "../../../layout";

import validate from "./form-validate";

const CaracteristicaCadastrar = () => {
  const location = useLocation();
  const history = useHistory();

  const [state, setState] = useState({
    id: 0,
    nome: "",
    nome_in: "",
    nome_es: "",
    ativo: true,
    detalhamentos: [],
  });

  const [stateDetalhamento, setStateDetalhamento] = useState({
    id: 0,
    caracteristica_id: 0,
    nome: "",
    ativo: true,
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-caracteristica").valid()) {
      return;
    }

    try {
      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/caracteristica", state);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      history.push("/caracteristica");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar a característica.");
    }
  };

  useEffect(() => {
    const carregarDados = async () => {
      if (!location.state) {
        return;
      }

      try {
        showLoading(".ibox-content");

        const requisicao = await api.get(
          `/caracteristica/${location.state.id}`
        );

        const { data } = requisicao;

        if (!data.status) {
          danger(data.mensagem);
          return;
        }

        if (!data.data) {
          return;
        }

        setState(data.data);
        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados da característica");
      }
    };

    let validacao = window.$("#form-caracteristica").validate(validate);

    carregarDados();

    return () => validacao.destroy();
  }, [location.state]);

  const adicionarDetalhamento = (event) => {
    event.preventDefault();

    if (stateDetalhamento.nome === "") {
      danger("O nome é obrigatório.");
      return;
    }

    let exists = state.detalhamentos.find(
      (item) => item.nome === stateDetalhamento.nome
    );

    if (exists) {
      danger("Já existe um detalhamento cadastrado.");
      return;
    }

    setState({
      ...state,
      detalhamentos: [
        ...state.detalhamentos,
        {
          id: 0,
          caracteristica_id: 0,
          nome: stateDetalhamento.nome,
          ativo: true,
        },
      ],
    });

    setStateDetalhamento({
      id: 0,
      caracteristica_id: 0,
      nome: "",
      nome_in: "",
      nome_es: "",
      ativo: true,
    });
  };

  const deletarDetalhamento = (detalhamento) => {
    setState({
      ...state,
      detalhamentos: state.detalhamentos.filter((detalhe) =>
        detalhe.id > 0
          ? detalhe.id !== detalhamento.id && detalhe.nome !== detalhamento.nome
          : detalhe.nome !== detalhamento.nome
      ),
    });
  };

  return (
    <>
      <Layout
        titulo="Ibraflex - Características"
        header="Cadastro do Característica"
        action={{ titulo: "Voltar", link: "/caracteristica" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Dados da característica</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                <div className="row">
                  <div className="col-lg-12">
                    <form id="form-caracteristica">
                      <div className="row">
                        
                        <div className="col-lg-9">
                          <div className="form-group">
                            <div class="tabs-container">
                              <ul class="nav nav-tabs" role="tablist">
                                <li>
                                  <a
                                    class="nav-link active nav-tab"
                                    data-toggle="tab"
                                    href="#tab-1"
                                  >
                                    Português
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="nav-link nav-tab"
                                    data-toggle="tab"
                                    href="#tab-2"
                                  >
                                    Inglês
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="nav-link nav-tab"
                                    data-toggle="tab"
                                    href="#tab-3"
                                  >
                                    Espanhol
                                  </a>
                                </li>
                              </ul>
                              <div class="tab-content">
                                <div
                                  role="tabpanel"
                                  id="tab-1"
                                  class="tab-pane active"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Nome da característica</label>
                                          <input
                                            type="text"
                                            placeholder="Nome da característica"
                                            className="form-control"
                                            name="nome"
                                            value={state.nome}
                                            onChange={(e) => preencherValoresEdits(e)}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  role="tabpanel"
                                  id="tab-2"
                                  class="tab-pane"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Nome da característica</label>
                                          <input
                                            type="text"
                                            placeholder="Nome da característica"
                                            className="form-control"
                                            name="nome_in"
                                            value={state.nome_in}
                                            onChange={(e) => preencherValoresEdits(e)}
                                          />
                                        </div>                                     
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  role="tabpanel"
                                  id="tab-3"
                                  class="tab-pane"
                                >
                                  <div class="panel-body">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="form-group">
                                          <label>Nome da característica</label>
                                          <input
                                            type="text"
                                            placeholder="Nome da característica"
                                            className="form-control"
                                            name="nome_es"
                                            value={state.nome_es}
                                            onChange={(e) => preencherValoresEdits(e)}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                      
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          
                        </div>
                        <div className="col-lg-3">
                          <div className="form-group">
                            <label>Status da característica</label>
                            <select
                              className="form-control"
                              id="ativo"
                              name="ativo"
                              value={state.ativo}
                              onChange={(e) => preencherValoresEdits(e)}
                            >
                              <option key="1" value={true}>
                                Ativo
                              </option>

                              <option key="2" value={false}>
                                Inativo
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-lg-10">
                        <div class="tabs-container">
                            <ul class="nav nav-tabs" role="tablist">
                              <li>
                                <a
                                  class="nav-link active nav-tab"
                                  data-toggle="tab"
                                  href="#tab-1"
                                >
                                  Português
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link nav-tab"
                                  data-toggle="tab"
                                  href="#tab-2"
                                >
                                  Inglês
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link nav-tab"
                                  data-toggle="tab"
                                  href="#tab-3"
                                >
                                  Espanhol
                                </a>
                              </li>
                            </ul>
                            <div class="tab-content">
                              <div
                                role="tabpanel"
                                id="tab-1"
                                class="tab-pane active"
                              >
                                <div class="panel-body">
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <label>Nome do detalhamento</label>
                                        <input
                                          type="text"
                                          placeholder="Nome do detalhamento"
                                          className="form-control"
                                          name="nome"
                                          value={stateDetalhamento.nome}
                                          onChange={(event) => {
                                            setStateDetalhamento({
                                              ...stateDetalhamento,
                                              nome: event.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                role="tabpanel"
                                id="tab-2"
                                class="tab-pane"
                              >
                                <div class="panel-body">
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <label>Nome do detalhamento</label>
                                        <input
                                          type="text"
                                          placeholder="Nome do detalhamento"
                                          className="form-control"
                                          name="nome_in"
                                          value={stateDetalhamento.nome_in}
                                          onChange={(event) => {
                                            setStateDetalhamento({
                                              ...stateDetalhamento,
                                              nome: event.target.value,
                                            });
                                          }}
                                        />
                                      </div>                                     
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                role="tabpanel"
                                id="tab-3"
                                class="tab-pane"
                              >
                                <div class="panel-body">
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <label>Nome do detalhamento</label>
                                        <input
                                          type="text"
                                          placeholder="Nome do detalhamento"
                                          className="form-control"
                                          name="nome_es"
                                          value={stateDetalhamento.nome_es}
                                          onChange={(event) => {
                                            setStateDetalhamento({
                                              ...stateDetalhamento,
                                              nome: event.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                    
                                </div>
                              </div>
                            </div>
                          </div>
                          
                        </div>
                        <div className="col-lg-2">
                          <div className="form-group">
                            <label htmlFor="button">Adicionar</label>
                            <button
                              type="button"
                              className="btn btn-primary btn-block"
                              onClick={adicionarDetalhamento}
                            >
                              <i className="fa fa-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        {state.detalhamentos &&
                        state.detalhamentos.length > 0 ? (
                          state.detalhamentos.map((detalhamento) => (
                            <div className="col-lg-3" key={Math.random()}>
                              <div className="form-group">
                                <div
                                  className="toast toast-bootstrap show"
                                  role="alert"
                                  aria-live="assertive"
                                  aria-atomic="true"
                                >
                                  <div className="toast-header">
                                    <strong className="mr-auto m-l-sm">
                                      Detalhamento
                                    </strong>
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-xs"
                                      onClick={(e) =>
                                        deletarDetalhamento(detalhamento)
                                      }
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  </div>
                                  <div className="toast-body">
                                    <div className="row">
                                      <div className="col col-lg-12">
                                        Nome: {""}
                                        <strong>{detalhamento.nome}</strong>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="col col-lg-12">
                            <div className="form-group">
                              <span>Nenhum detalhamento cadastrado.</span>
                            </div>
                          </div>
                        )}
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-success float-right m-t-n-xs"
                          type="submit"
                          onClick={(e) => enviarFormulario(e)}
                        >
                          <strong>Salvar</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default CaracteristicaCadastrar;
